import { DegreeCompletionBlockCourse } from './degree_completion_block_course_builder';
import { IFilterNumber } from 'angular';

export class DegreeCompletionRequirement {
  static ngDegreeCompletionBlockCourseBuilder: typeof DegreeCompletionBlockCourse;
  static numberFilter: ng.IFilterNumber;

  label: string = '';
  is_completed: boolean = false;
  transferred_classes: DegreeCompletionBlockCourse[] = [];
  credits_applied: number = 0.0;
  displayAppliedCredits: string = '0';

  constructor(requirement: any) {
    _.merge(this, requirement);
    this.transferred_classes = _.map(this.transferred_classes, (transferred_class) =>
      DegreeCompletionRequirement.ngDegreeCompletionBlockCourseBuilder.build(transferred_class)
    );
    this.displayAppliedCredits = DegreeCompletionRequirement.numberFilter(
      DegreeCompletionRequirement.numberFilter(this.credits_applied, 2)
    );
  }

  static build(requirement: any): DegreeCompletionRequirement {
    return new DegreeCompletionRequirement(requirement);
  }
}

angular
  .module('capability-ng-transfer')
  .factory(
    'ngDegreeCompletionRequirementBuilder',
    (
      ngDegreeCompletionBlockCourseBuilder: typeof DegreeCompletionBlockCourse,
      numberFilter: ng.IFilterNumber
    ): typeof DegreeCompletionRequirement => {
      DegreeCompletionRequirement.numberFilter = numberFilter;
      DegreeCompletionRequirement.ngDegreeCompletionBlockCourseBuilder = ngDegreeCompletionBlockCourseBuilder;
      return DegreeCompletionRequirement;
    }
  );



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/degree_completion_requirement_builder.ts